import React from "react";

import { Button } from "@mui/material";
import { useMsal } from "@azure/msal-react";

import apiCall from "../../utils/apiCall";
import { CREATE_NEW_CONVERSATION } from "../../endpoint";

import add_chat_svg from "../../assets/addChat.svg";

import { useAppDispatch, useAppSelector } from "../../hooks/reduxhook";
import {
  addConversations,
  addconversation,
} from "../../redux/slices/conversationSlice";
import { loadingforconversation } from "../../redux/slices/loadingSlice";
import {
  adddrawerOpening,
  removedrawerOpening,
} from "../../redux/slices/drawerOpening";
import { addType, removeType } from "../../redux/slices/typeSlice";

import types from "../../data/types";
import { addModel, getModelDetails } from "../../redux/slices/modelSlice";
import { addError } from "../../redux/slices/errorSlice";
import { DEFAULT_LLM_MODEL, FALLBACK_LLM_MODEL } from "../../data/constants";

const findModelInType = (type: string, models: any, modelName: string) => {
  return models?.models?.[type]?.find(
    (model: any) => model?.model_name === modelName
  )?.model_name;
};

export const getDefaultModel = (
  models: any,
  defaultModelName?: string,
  chatType = "chat",
  preSelectedModel?: string
) => {
  // Try models in priority order and return the first match
  return (
    // 1. Pre-selected model
    (preSelectedModel && findModelInType(chatType, models, preSelectedModel)) ||
    // 2. Default model
    (defaultModelName && findModelInType(chatType, models, defaultModelName)) ||
    // 3. Fallback model
    (defaultModelName &&
      findModelInType(chatType, models, FALLBACK_LLM_MODEL)) ||
    // 4. First available model
    models?.models?.[chatType]?.[0]?.model_name
  );
};
const NewConversationButton = () => {
  const dispatch = useAppDispatch();

  const { accounts } = useMsal();
  const account = accounts[0];

  const models = useAppSelector(getModelDetails);

  const createConveration = () => {
    dispatch(loadingforconversation(true));
    // dispatch(adddrawerOpening());
    // dispatch(removeType());
    apiCall("POST", CREATE_NEW_CONVERSATION, {
      user_email: account.username,
      conv_name: "New Chat",
    })
      .then((res) => {
        const result = res.result;
        dispatch(addConversations(result));
        dispatch(
          addconversation({
            conversation_id: result[0].id,
            chats: [],
          })
        );
        dispatch(addType(types[0]));
        dispatch(removedrawerOpening());
        dispatch(
          addModel(
            process.env?.REACT_APP_DEFAULT_LLM_MODEL ??
              getDefaultModel(models, DEFAULT_LLM_MODEL)
          )
        );
      })
      .catch((err) => {
        dispatch(
          addError("Failed to create a new conversation.Please try again.")
        );
      })
      .finally(() => {
        dispatch(loadingforconversation(false));
      });
  };
  return (
    <Button
      id="newconversation"
      variant="contained"
      color="primary"
      startIcon={<img src={add_chat_svg} width="15px" />}
      sx={{
        margin: "20px auto",
        width: "90%",
      }}
      onClick={createConveration}
    >
      New Conversation
    </Button>
  );
};

export default NewConversationButton;
